import React, { useEffect, useState } from "react";

import SyDialog from "../../../components/SyDialog";
import useBankingOptions from "../useBankingOptions";

const PRESETS = {
  BANK: {
    title: "Add Bank Account",
    subtitle: "Where should we send your withdrawals?",
    providerLabel: "Bank",
    providerPlaceholder: "Select a bank",
    numberLabel: "Account Number",
    codeField: "bankCode",
  },
  MOBILE_MONEY: {
    title: "Add Mobile Money",
    subtitle: "Where should we send your withdrawals?",
    providerLabel: "Operator",
    providerPlaceholder: "Select an operator",
    numberLabel: "Mobile Number",
    codeField: "operatorCode",
  },
};

const AddRecipientSheet = ({ open, kind = "BANK", currency, saving = false, onClose, onSubmit }) => {
  const preset = PRESETS[kind] || PRESETS.BANK;
  const [accountName, setAccountName] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [providerCode, setProviderCode] = useState("");

  const { options, isLoading, isError } = useBankingOptions({ kind, enabled: open });

  useEffect(() => {
    if (!open) {
      setAccountName("");
      setAccountNumber("");
      setProviderCode("");
    }
  }, [open, kind]);

  const canSubmit =
    Boolean(accountName.trim()) && Boolean(accountNumber.trim()) && Boolean(providerCode) && !saving;

  const handleSubmit = (event) => {
    event.preventDefault();

    if (!canSubmit) return;

    onSubmit({
      type: kind,
      accountName,
      accountNumber,
      currency,
      [preset.codeField]: providerCode,
    });
  };

  return (
    <SyDialog open={open} title={preset.title} subtitle={preset.subtitle} size="sm" onClose={onClose}>
      <form className="fin-form" onSubmit={handleSubmit}>
        <label className="fin-field">
          <span className="fin-field-label">{preset.providerLabel}</span>

          <select
            value={providerCode}
            disabled={isLoading || isError}
            onChange={(event) => setProviderCode(event.target.value)}
          >
            <option value="">
              {isError ? "Could not load the list" : isLoading ? "Loading…" : preset.providerPlaceholder}
            </option>

            {options.map((option) => (
              <option key={option.code} value={option.code}>
                {option.name}
              </option>
            ))}
          </select>
        </label>

        <label className="fin-field">
          <span className="fin-field-label">Account Name</span>

          <input
            type="text"
            autoComplete="off"
            value={accountName}
            onChange={(event) => setAccountName(event.target.value)}
          />
        </label>

        <label className="fin-field">
          <span className="fin-field-label">{preset.numberLabel}</span>

          <input
            type="text"
            inputMode="numeric"
            autoComplete="off"
            value={accountNumber}
            onChange={(event) => setAccountNumber(event.target.value)}
          />
        </label>

        <button
          type="submit"
          className="sy-flow-btn sy-flow-btn-primary fin-amount-submit"
          disabled={!canSubmit}
        >
          {saving ? "Saving…" : "Save Account"}
        </button>
      </form>
    </SyDialog>
  );
};

export default AddRecipientSheet;
